import React, { useState } from 'react';
import styled from 'styled-components';
import { BlueBorderButton, BlueButton } from 'components/Button';
import Modal, { ModalMessage } from 'components/Modal';
import { useSelector } from 'react-redux';
import { RESOURCE_TYPES } from 'utils/appConstants';

const ModalHeader = styled.p`
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 12px;
  max-width: 550px;
`;

const ButtonRow = styled.div``;

const DeleteModal = ({ toggleDeleteModal, handleDelete }) => {
  const sidePanel = useSelector(state => state.sidePanel);
  const devices = useSelector(state => state.device.devices);
  const aggregators = useSelector(state => state.aggregator.aggregators);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDeletes = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    handleDelete();
  };

  const { entity, id } = sidePanel;
  let lfdi = '';
  if (entity === RESOURCE_TYPES.DEVICE) {
    lfdi = devices.find(device => device.deviceId === id).lfdi;
  } else if (entity === RESOURCE_TYPES.AGGREGATOR) {
    lfdi = aggregators.find(aggregator => aggregator.aggregatorId === id).lfdi;
  }

  return (
    <Modal>
      <ModalHeader>
        Are you sure you want to delete {entity} {id}?
      </ModalHeader>
      {entity === RESOURCE_TYPES.DEVICE ||
      entity === RESOURCE_TYPES.AGGREGATOR ? (
        <ModalHeader paddingBottom="24px">(LFDI: {lfdi})</ModalHeader>
      ) : entity === RESOURCE_TYPES.CURVE ? (
        <ModalMessage>
          This curve will still be applied to any associated controls and will
          need to be cancelled manually.
        </ModalMessage>
      ) : entity === RESOURCE_TYPES.TOPONODE ||
        entity === RESOURCE_TYPES.INDENODE ? (
        <>
          <ModalMessage>
            Any currently scheduled controls will still be applied to associated
            devices and will need to be cancelled manually
          </ModalMessage>
          {entity === RESOURCE_TYPES.TOPONODE && (
            <ModalMessage style={{ paddingTop: '0', paddingBottom: '1.5em' }}>
              All descendant nodes will also be deleted
            </ModalMessage>
          )}{' '}
        </>
      ) : null}

      <ButtonRow>
        <BlueBorderButton
          margin="0 16px 0 0"
          onClick={() => toggleDeleteModal()}
        >
          Cancel
        </BlueBorderButton>
        <BlueButton onClick={handleDeletes} disabled={isSubmitting}>
          Delete {entity}
        </BlueButton>
      </ButtonRow>
    </Modal>
  );
};

export default DeleteModal;
